import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { Users } from 'lucide-react';
import Spinner from 'src/componentes/spinner';
import http from 'src/services/httpService';
import useAuth from 'src/hooks/useAuth';

export default function PublicoInteressadoContador({
  documentoId,
  criterios,
  hasLift,
  hasCriterios,
  enabled = true,
}) {
  const intl = useIntl();
  const { terms } = useAuth();
  const [result, setResult] = useState(null);
  const requestKey = JSON.stringify({
    documentoId: documentoId ?? null,
    criterios: {
      ...criterios,
      tempoMinimoCargoDias: hasLift ? criterios.tempoMinimoCargoDias : null,
      cargos: hasLift ? criterios.cargos : [],
    },
  });

  useEffect(() => {
    if (!enabled || !hasCriterios) return;

    let cancelled = false;
    setResult(null);
    const timeout = setTimeout(async () => {
      try {
        const response = await http.post(
          '/DocumentoPublicoInteressado/Previsualizar',
          { ...JSON.parse(requestKey), pagina: 1, tamanhoPagina: 1 }
        );
        const total = response.data?.total;
        if (!Number.isInteger(total) || total < 0) throw new Error();
        if (!cancelled) setResult({ key: requestKey, total });
      } catch {
        if (!cancelled) setResult({ key: requestKey, hasError: true });
      }
    }, 400);

    return () => {
      cancelled = true;
      clearTimeout(timeout);
    };
  }, [requestKey, hasCriterios, enabled]);

  if (!enabled) return null;

  const currentResult = result?.key === requestKey ? result : null;
  const isLoading = !!hasCriterios && !currentResult;
  const total = hasCriterios ? currentResult?.total : 0;
  let message;
  if (isLoading) {
    message = intl.formatMessage({ id: 'msgContandoPublicoInteressado' });
  } else if (hasCriterios && currentResult?.hasError) {
    message = intl.formatMessage({ id: 'msgErroPreviaPublicoInteressado' });
  } else {
    message = intl.formatMessage(
      {
        id:
          total === 1
            ? 'msgPreviaPublicoInteressadoSingular'
            : 'msgPreviaPublicoInteressadoPlural',
      },
      {
        quantidade: total,
        colaborador: terms.colaborador,
        colaboradores: terms.colaboradores,
      }
    );
  }

  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy={isLoading}
      className="tw:inline-flex tw:items-center tw:gap-2 tw:rounded-md tw:bg-muted tw:px-3 tw:py-2 tw:text-sm tw:font-medium tw:text-foreground"
    >
      {isLoading ? (
        <Spinner aria-hidden className="tw:shrink-0" />
      ) : (
        <Users aria-hidden="true" className="tw:size-4 tw:shrink-0" />
      )}
      <span>{message}</span>
    </div>
  );
}
